<template>
  <div class="share-goods-container" @click="close" v-if="visible_c">
    <div class="poster">
      <div class="card" @click.stop>
        <div class="head">
          <div
            class="img"
            :style="{ backgroundImage: 'url(' + goods_detail.logoUrl + ')' }"
          ></div>
          <div class="head-r">
            <div class="title">{{ goods_detail.activityName }}</div>
            <div class="subtitle">
              <div class="brand">{{ goods_detail.brandName }}</div>
            </div>
          </div>
        </div>
        <div class="img-wrapper">
          <div class="img-l">
            <div
              class="img"
              :style="{
                backgroundImage: 'url(' + goods_detail.posterImg + ')',
              }"
            ></div>
          </div>
          <div class="img-r">
            <div
              class="img"
              :style="{
                backgroundImage: 'url(' + goods_detail.rightImgOne + ')',
              }"
            ></div>
            <div
              class="img"
              :style="{
                backgroundImage: 'url(' + goods_detail.rightImgTwo + ')',
              }"
            ></div>
          </div>
        </div>
        <div class="goods-name">
          {{ goods_detail.goodsName }}
        </div>
        <div class="detail">
          <div class="detail-l">
            <div
              class="suit"
              v-if="
                goods_detail.specDetailList &&
                goods_detail.specDetailList.length
              "
            >
              规格: {{ goods_detail.specDetailList.join("/") }}
            </div>
            <div class="amount">
              <div class="title">
                <span> ¥ </span>
                <span class="num">{{ goods_detail.price }}</span>
              </div>
              <div class="subtitle">
                <span>赚：{{ saveProfit_c }}</span>
              </div>
            </div>
          </div>
          <div class="detail-r">
            {{ dayjs(goods_detail.activityTime).format("MM月DD日 HH:mm") }} 结束
          </div>
        </div>
        <div class="tools">
          <div class="title">加价：</div>
          <div class="select">
            <div
              class="item"
              :class="{ active: selected === 1 }"
              @click="selected = 1"
            >
              不加价
            </div>
            <div
              class="item"
              :class="{ active: selected === 2 }"
              @click="selected = 2"
            >
              加价10元
            </div>
            <div
              class="item"
              :class="{ active: selected === 3 }"
              @click="selected = 3"
            >
              加价20%
            </div>
          </div>
          <div class="select-input">
            <Field
              :class="{ active: selected === 4 }"
              type="digit"
              placeholder="自定义金额"
              input-align="center"
              v-model="custom_amount"
              @click="selected = 4"
            />
          </div>
        </div>
      </div>
      <div class="submit" @click.stop="createPoster">生成海报</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validAmount } from "@/utils/vaildate";
import { Field, Toast } from "vant";
import { priceMarkup } from "@/api/forward";
export default {
  components: { Field },
  data() {
    return {
      selected: 1,
      custom_amount: null,
    };
  },
  watch: {
    visible(val) {
      if (val && this.distributionFlag === false) {
        this.createPoster()
      }
    },
    $route: {
      handler: function (route) {
        this.close();
      },
    },
  },
  computed: {
    ...mapState({
      distributionFlag: (state) => state.user.distributionFlag,
      visible: (state) => state.shareGoods.visible,
      goods_detail: (state) => state.shareGoods.goods_detail,
      share_options: (state) => state.shareGoods.share_options,
    }),
    visible_c() {
      return this.visible && this.distributionFlag
    },
    saveProfit_c() {
      if (this.goods_detail.activityReward === 'COMMISSION') {
        // return Math.round((this.goods_detail.saveProfit * 100) * 2) / 100
        return this.goods_detail.saveProfit + ' x 2'
      }
      return this.goods_detail.saveProfit
    }
  },
  methods: {
    createPoster() {
      if (this.selected === 4 && !validAmount(this.custom_amount)) {
        return Toast.fail("请正确输入金额");
      }
      const forwardUrl = `${window.location.origin}/goodsDetail/${this.goods_detail.partGoodsId}?customerId=${this.$store.state.user.forwardId}`;
      const params = {
        actId: this.goods_detail.actId,
        partId: this.goods_detail.partId,
        partGoodsId: this.goods_detail.partGoodsId,
        goodsId: this.goods_detail.goodsId,
        forwardType: "GOODS",
        markupType: "NONE",
        retailId: null,
        markupAmount: 0,
        markupRatio: 0,
        urlAddress: forwardUrl,
      };
      if (this.selected === 1) {
        params.price = this.goods_detail.price;
      }
      if (this.selected === 2) {
        params.markupType = "AMOUNT";
        params.markupAmount = 10;
        params.price =
          Math.round(this.goods_detail.price * 100 + 10 * 100) / 100;
      }
      if (this.selected === 3) {
        params.markupType = "RATIO";
        params.markupRatio = 0.2;
        params.price = Math.round(this.goods_detail.price * 100 * 1.2) / 100;
      }
      if (this.selected === 4) {
        params.markupType = "AMOUNT";
        params.markupAmount = Math.round(this.custom_amount * 100) / 100;
        params.price =
          Math.round(
            this.goods_detail.price * 100 + params.markupAmount * 100
          ) / 100;
      }
      this.$store.dispatch("app/showLoading");
      priceMarkup(params)
        .then((res) => {
          console.log("dasdas", res);
          this.$store.dispatch("app/hideLoading");
          this.sharePosterOpen(res.data.url, forwardUrl, this.goods_detail);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    sharePosterOpen(url, forwardUrl, data) {
      this.close();
      this.$store.dispatch("sharePoster/show", {
        url,
        title: this.share_options.title,
        desc: this.share_options.desc,
        link: forwardUrl,
        imgUrl: this.share_options.imgUrl,
      });
    },
    close() {
      this.selected = 1;
      this.custom_amount = null;
      this.$store.dispatch("shareGoods/hide");
    },
  },
};
</script>

<style lang="less" scoped>
.share-goods-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .poster {
    width: 600px;
    text-align: center;
    .card {
      padding: 20px;
      background: #ffffff;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 12px 12px 16px 16px;
      text-align: left;
      .head {
        display: flex;
        .img {
          width: 92px;
          height: 92px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          border-radius: 16px;
        }
        .head-r {
          flex: 1;
          min-width: 0;
          margin-left: 20px;
          .title {
            font-size: 24px;
            font-weight: 600;
            color: #333333;
            line-height: 34px;
          }
          .subtitle {
            padding-top: 12px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 34px;
          }
        }
      }
      .img-wrapper {
        display: flex;
        .img {
          width: 100%;
          padding-top: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          border-radius: 8px;
        }
        .img-l {
          flex: 1;
          min-width: 0;
        }
        .img-r {
          width: 180px;
          margin-left: 8px;
          .img + .img {
            margin-top: 8px;
          }
        }
      }
      .goods-name {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 38px;
        padding-top: 16px;
      }
      .detail {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        padding-top: 16px;
        .detail-l {
          .suit {
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 28px;
            padding-bottom: 20px;
          }
          .amount {
            display: flex;
            .title {
              font-size: 24px;
              font-weight: 400;
              color: #e82035;
              line-height: 28px;
              .num {
                font-size: 40px;
                font-weight: bold;
              }
            }
            .subtitle {
              margin-left: 12px;
              padding-top: 8px;
              font-size: 20px;
              font-weight: 600;
              color: #e82035;
              line-height: 24px;
            }
          }
        }
        .detail-r {
          font-size: 24px;
          font-weight: 400;
          color: #333333;
          line-height: 34px;
        }
      }
      .tools {
        padding-top: 32px;
        .title {
          font-size: 24px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
        }
        .select {
          display: flex;
          padding-top: 16px;
          .item {
            flex: 4;
            min-width: 0;
            font-size: 24px;
            font-weight: 400;
            color: #333;
            line-height: 24px;
            text-align: center;
            padding: 18px 0;
            background: #f1f1f1;
            border-radius: 8px;
            & + .item {
              margin-left: 14px;
            }
            &.active {
              background: #e82035;
              color: #fff;
            }
          }
        }
        .select-input {
          margin-top: 16px;
          .van-field {
            padding: 15px 0;
            background: #f1f1f1;
            border-radius: 8px;
            border: 1px solid #f1f1f1;
            &.active {
              border: 1px solid #e82035;
              color: #fff;
            }
          }
          .van-field /deep/ input {
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            &::placeholder {
              color: #333;
            }
          }
        }
      }
    }
    .submit {
      margin-top: 80px;
      font-size: 28px;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      padding-top: 14px;
      width: 670px;
      margin-left: -35px;
      height: 68px;
      background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
      border-radius: 38px;
      border: 2px solid #fe6979;
    }
    .card-img {
      width: 100%;
      img {
        width: 100%;
        height: auto;
        border-radius: 16px;
      }
      .tip {
        padding-top: 30px;
        color: #fff;
        font-size: 28px;
      }
    }
  }
}
</style>